import React from 'react';

function ManualDedupePageHeader () {
  return (
    <h1>Manual Dedupe</h1>
  );
}

export default ManualDedupePageHeader;
